import { Alert, Platform } from 'react-native'

const alertPolyfill = (title: string, description: string) => {
  window.confirm([title, description].filter(Boolean).join('\n'))
}

export const alert = Platform.OS === 'web' ? alertPolyfill : Alert.alert
